import React, { useState } from "react";
import { timeStringToTimeAMPM } from "../../../utils/utils";
import { getModeValue } from "../../../utils/constants/deviceConstants";
import { useTranslation } from "react-i18next";

const AuditTrailReport = ({ reportData }) => {
  const { t } = useTranslation("reports");

  const [isAllSite, setIsAllSite] = useState(false);

  const userActionTypeGenerator = (data) => {
    let result;

    if (data) {
      result = t(
        `reportFilter.auditTrail.userActionTypeEnums.${data}`
      );
    } else {
      result = "-";
    }

    return result;
  };

  const userActionGenerator = (data) => {
    let result;

    if (data) {
      result = t(`reportFilter.auditTrail.userActionEnums.${data}`);
    } else {
      result = "-";
    }

    return result;
  };

  const timeGenerator = (data) => {
    let result;

    if (data) {
      result = timeStringToTimeAMPM(data);
    } else {
      result = "-";
    }
    return result;
  };

  return (
    <>
      {reportData?.map((data, i) => {
        data.mode = getModeValue(data?.mode); // to handle invalid mode value
        return (
          <tr key={`${data?.eventUUID}${i + 1}`}>
            <td>
              {data?.actionPerformedByEmail
                ? data.actionPerformedByEmail
                : "-"}
            </td>
            <td>{userActionTypeGenerator(data?.userActionType)}
            </td>
            <td>{userActionGenerator(data?.userAction)}</td>
            <td>
              {data?.userAction === "LogIn" ? (
                `${t(
                  "reportFilter.auditTrail.userActionLoginDesc"
                )} ${timeGenerator(data?.eventTimeStamp)}`
              ) : (
                <>
                  {data?.userActionDescription
                    ? data.userActionDescription
                    : "-"}
                </>
              )}
            </td>
            {isAllSite && (
              <td>{data.data.siteName ? data.data.siteName : "-"}</td>
            )}
            <td>{data?.data?.deviceName ? data.data.deviceName : "-"}</td>
            <td>{data?.deviceUdi ? data.deviceUdi : "-"}</td>
            <td>{timeGenerator(data?.eventTimeStamp)}</td>
          </tr>
        );
      })}
    </>
  );
};

export default AuditTrailReport;
